import { DownloadFileDto, fromDateString, UpdateInvoiceWccSupplierDto, UpdateWccDto, WccDto, WccStatus } from '@sr/dto';
import { FormTools, VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';
import { FormikErrors } from 'formik';
import { isValidWccAmount, WCC_AMOUNT_FORMAT_ERROR } from 'utils/wcc-amount';


export type FormValues = {
  amount: number | string,
  date: Date | '' | string,
  status: WccStatus,
  wccNumber: string | '',
  sellerSignerId: number,
  aktFile: DownloadFileDto[] | null ,
  updFile: DownloadFileDto[] | null,
  otherFiles: DownloadFileDto[]
};

export const formTools: FormTools<WccDto, void, UpdateInvoiceWccSupplierDto, FormValues> = {
  toUpdateDto: (id, formData) => ({
    id: id,
    status: formData.status as WccStatus,
    date: new Date(formData.date),
    amount: Number(formData.amount),
    wccNumber: formData.wccNumber,
    aktFile: formData.aktFile?.length ? formData.aktFile[0] : null,
    aktFiles: formData.aktFile ?? [],
    updFile: formData.updFile?.length ? formData.updFile[0] : null,
    updFiles: formData.updFile ?? [],
    sellerSignerId: formData.sellerSignerId,
    otherFiles: formData.otherFiles
  }),

  toCreateDto: formData => { },

  fromDto: (dto) => ({
    amount: dto.amount,
    status: dto.status,
    date: new Date(dto.date),
    wccNumber: dto.wccNumber,
    sellerSignerId: dto.sellerSignerId,
    aktFile: dto.aktFiles ?? (dto.aktFile ? [dto.aktFile] : null),
    updFile: dto.updFiles ?? (dto.updFile ? [dto.updFile] : null),
    otherFiles: dto.otherFiles
  }),

  validate: (values: FormValues): FormikErrors<FormValues> => {
    let validationResult: FormikErrors<FormValues> = {};

    if (!values.wccNumber?.trim())
      validationResult.wccNumber = VALIDATION_REQUIRED_FIELD;

    if (!values.date)
      validationResult.date = VALIDATION_REQUIRED_FIELD;
    if (values.amount === '')
      validationResult.amount = VALIDATION_REQUIRED_FIELD;
    else if (!isValidWccAmount(values.amount))
      validationResult.amount = WCC_AMOUNT_FORMAT_ERROR;

    return validationResult;
  },

  emptyValues: () => ({
    status: WccStatus.READY,
    sellerSignerId: 0,
    amount: 0,
    date: new Date(),
    wccNumber: '',
    aktFile: null,
    updFile: null,
    otherFiles: []
  })
};
